module.exports = __webpack_public_path__ + "static/media/2030081000.fd4392ce.jpg";